export const TextVariants = {
  size: {
    '12': { fontSize: '$12' },
    '14': { fontSize: '$14' },
    '18': { fontSize: '$18' },
    '20': { fontSize: '$20' },
    '24': { fontSize: '$24' },
    '28': { fontSize: '$28' },
    '32': { fontSize: '$32' },
    '36': { fontSize: '$36' },
  },
  color: {
    primary: { color: '$primaryBase' },
    secondary: { color: '$secondaryBase' },
    warning: { color: '$warning600' },
    error: { color: '$error600' },
    success: { color: '$success600' },
    gray: { color: '$text' },
    darkGray: { color: '$gray800' },
    white: { color: '$whiteBase' },
    black: { color: '$blackBase' },
    disabled: { color: '$disabledText' },
    transparent: {},
  },
}

export const TextDefaultVariants = {
  size: '$14',
  color: '$blackBase',
}
